import { useSWRFetcher } from "./useSWRFetcher";
import { environment } from "../config/environment";
import useSWRMutation from "swr/mutation";
import { InvoiceExtractedRequestModel } from "@attelas/shared";

export const useSendInvoiceExtractedData = (id: string) => {
  const fetcher = useSWRFetcher();

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/payable-invoices/submit/${id}`,
    (url: string, { arg }: { arg: InvoiceExtractedRequestModel }) =>
      fetcher<{ result: string }>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      })
  );

  return {
    sendInvoiceExtractedData: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
